import React, { useState, useRef, useEffect } from "react";
import API_BASE_URL from '../config';
import axios from "axios";
//import he from "he";

export default function Home({ setScrollToContact, setScrollToCourse }) {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [welcomeTxt, setWelcomeTxt] = useState({});
  const [courseoneTxt, setcourseoneTxt] = useState({});
  const [coursetwoTxt, setcoursetwoTxt] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "", // Clear errors for the specific field
    });
  };

  // Validate form data
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email address.";
    if (!formData.contact) newErrors.contact = "Contact is required.";
    if (!formData.message) newErrors.message = "Message is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    // Clear previous success messages
    if (!validateForm()) {
      return; // Stop execution if validation fails
    }
    setIsLoading(true);

    try {
      console.log('before api calling for saving');
      const response = await fetch(`${API_BASE_URL}/postcontacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
      // Check if the API returned validation errors
      if (result.error) {
        const apiErrors = {};
        // Map the server validation error to the field
        Object.keys(result.error).forEach((key) => {
          apiErrors[key.toLowerCase()] = result.error[key];
        });
        setErrors(apiErrors);
      } else {
        throw new Error(result.message || "Something went wrong. Please try again.");
      }
      return;
    }

      setFormData({
        name: "",
        email: "",
        contact: "",
        message: "",
      });
      setSuccessMessage("Your message has been sent successfully!");
      setErrors({});
    } catch (error) {
      setErrors({ api: error.message });
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const contactRef = useRef(null);
  const scrollToContact = () => {
    contactRef.current.scrollIntoView({ behavior: "smooth" });
  };
  const courseRef = useRef(null);
  
  const fetchCmsContent = async (id, setState) => {
    try {
      /* const response = await fetch(`${API_BASE_URL}/getCmsById/${id}`);
      if (!response.ok) throw new Error("Failed to fetch content");
      const data = await response.json(); */
      const response = await axios.get(`${API_BASE_URL}/getCmsById/${id}`);
      //console.log("API Response:", response);
      //setState(response.data);
      if (response && response.data) {
        setState(response.data); // Ensure response contains data before setting state
      } else {
        console.error("Unexpected API response format:", response);
      }
    } catch (error) {
      console.error("API Error:", error.response ? error.response.data : error.message);
    }
  };
  //console.log("API Response:", welcomeTxt?.description);
  useEffect(() => {
    fetchCmsContent(1, setWelcomeTxt); // Fetch About Us content
    fetchCmsContent(2, setcourseoneTxt); // Fetch Services content
    fetchCmsContent(3, setcoursetwoTxt); // Fetch Contact Us content
    setScrollToContact(() => scrollToContact);
    setScrollToCourse(() => () => courseRef.current?.scrollIntoView({ behavior: "smooth" }));
  }, []);

  return (
    <>
      <section className="section main-banner" id="top" data-section="section1">
        <video autoPlay muted loop id="bg-video">
          <source src="assets/images/group-video.mp4" type="video/mp4" />
        </video>

        {/* <a href="#" className="floating-link" >Call to 7003423870</a> */}

        <div className="video-overlay header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="caption">
                  {/* <h6>Hello Students</h6> */}
                  <h2>{welcomeTxt.title}</h2>
                  <div className="wel-description" dangerouslySetInnerHTML={{ __html: welcomeTxt?.description || "" }}></div>
                  <div className="main-button-red">
                    <div className="scroll-to-section">
                      {/* <a href="#contact">Join Us Now!</a> */}
                      <a href="#" onClick={scrollToContact}>Join Us Now!</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="services">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="owl-service-item owl-carousel">
                <div className="item">
                  <div className="icon">
                    <img
                      src="assets/images/service-icon-01.png"
                      alt="Service Icon"
                    />
                  </div>
                  <div className="down-content">
                    <h4>Best Education</h4>
                    <p>
                      Suspendisse tempor mauris a sem elementum bibendum.
                      Praesent facilisis massa non vestibulum.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="upcoming-meetings" id="meetings">
        <div className="container">
        <div className="row">
            <div className="col-lg-12">
            <div className="section-heading">
                <h2>Upcoming Meetings</h2>
            </div>
            </div>
            <div className="col-lg-4">
            <div className="categories">
                <h4>Meeting Catgories</h4>
                <ul>
                <li><a href="#">Sed tempus enim leo</a></li>
                <li><a href="#">Aenean molestie quis</a></li>
                <li><a href="#">Cras et metus vestibulum</a></li>
                <li><a href="#">Nam et condimentum</a></li>
                <li><a href="#">Phasellus nec sapien</a></li>
                </ul>
                <div className="main-button-red">
                <a href="meetings.html">All Upcoming Meetings</a>
                </div>
            </div>
            </div>
            <div className="col-lg-8">
            <div className="row">
                <div className="col-lg-6">
                <div className="meeting-item">
                    <div className="thumb">
                    <div className="price">
                        <span>$22.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/meeting-01.jpg" alt="New Lecturer Meeting" /></a>
                    </div>
                    <div className="down-content">
                    <div className="date">
                        <h6>Nov <span>10</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>New Lecturers Meeting</h4></a>
                    <p>Morbi in libero blandit lectus<br/>cursus ullamcorper.</p>
                    </div>
                </div>
                </div>
                <div className="col-lg-6">
                <div className="meeting-item">
                    <div className="thumb">
                    <div className="price">
                        <span>$36.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/meeting-02.jpg" alt="Online Teaching" /></a>
                    </div>
                    <div className="down-content">
                    <div className="date">
                        <h6>Nov <span>24</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>Online Teaching Techniques</h4></a>
                    <p>Morbi in libero blandit lectus<br/>cursus ullamcorper.</p>
                    </div>
                </div>
                </div>
                <div className="col-lg-6">
                <div className="meeting-item">
                    <div className="thumb">
                    <div className="price">
                        <span>$14.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/meeting-03.jpg" alt="Higher Education" /></a>
                    </div>
                    <div className="down-content">
                    <div className="date">
                        <h6>Nov <span>26</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>Higher Education Conference</h4></a>
                    <p>Morbi in libero blandit lectus<br/>cursus ullamcorper.</p>
                    </div>
                </div>
                </div>
                <div className="col-lg-6">
                <div className="meeting-item">
                    <div className="thumb">
                    <div className="price">
                        <span>$48.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/meeting-04.jpg" alt="Student Training" /></a>
                    </div>
                    <div className="down-content">
                    <div className="date">
                        <h6>Nov <span>30</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>Student Training Meetup</h4></a>
                    <p>Morbi in libero blandit lectus<br/>cursus ullamcorper.</p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>      
      </section> */}

      <section className="apply-now" id="apply" ref={courseRef}>
        <div className="container">
        <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="row">
                  <div className="col-lg-12">
                      <div className="item">
                          <h3 dangerouslySetInnerHTML={{ __html: courseoneTxt.title || "" }}></h3>                          
                          <p>{courseoneTxt.description}</p>
                          <div className="main-button-red">
                            <div className="scroll-to-section"><a href="javascript:void(0)" onClick={scrollToContact}>Join Us Now!</a>
                            </div>
                          </div>
                      </div>
                  </div>
                  
            </div>
            </div>
            <div className="col-lg-6">
                <div className="col-lg-12">
                      <div className="item">
                          <h3 dangerouslySetInnerHTML={{ __html: coursetwoTxt.title || "" }}></h3>
                          <p>{coursetwoTxt.description}</p>
                          <div className="main-button-yellow">
                            <div className="scroll-to-section"><a href="javascript:void(0)" onClick={scrollToContact}>Join Us Now!</a>
                          </div>
                         </div>
                  </div>
                  </div>
            </div>
            {/* <div className="col-lg-6">
            <div className="accordions is-first-expanded">
                <article className="accordion">
                    <div className="accordion-head">
                        <span>About Edu Meeting HTML Template</span>
                        <span className="icon">
                            <i className="icon fa fa-chevron-right"></i>
                        </span>
                    </div>
                    <div className="accordion-body">
                        <div className="content">
                            <p>If you want to get the latest collection of HTML CSS templates for your websites, you may visit <a rel="nofollow" href="https://www.toocss.com/" target="_blank">Too CSS website</a>. If you need a working contact form script, please visit <a href="https://templatemo.com/contact" target="_parent">our contact page</a> for more info.</p>
                        </div>
                    </div>
                </article>
                <article className="accordion">
                    <div className="accordion-head">
                        <span>HTML CSS Bootstrap Layout</span>
                        <span className="icon">
                            <i className="icon fa fa-chevron-right"></i>
                        </span>
                    </div>
                    <div className="accordion-body">
                        <div className="content">
                            <p>Etiam posuere metus orci, vel consectetur elit imperdiet eu. Cras ipsum magna, maximus at semper sit amet, eleifend eget neque. Nunc facilisis quam purus, sed vulputate augue interdum vitae. Aliquam a elit massa.<br/><br/>
                            Nulla malesuada elit lacus, ac ultricies massa varius sed. Etiam eu metus eget nibh consequat aliquet. Proin fringilla, quam at euismod porttitor, odio odio tempus ligula, ut feugiat ex erat nec mauris. Donec viverra velit eget lectus sollicitudin tincidunt.</p>
                        </div>
                    </div>
                </article>
                <article className="accordion">
                    <div className="accordion-head">
                        <span>Please tell your friends</span>
                        <span className="icon">
                            <i className="icon fa fa-chevron-right"></i>
                        </span>
                    </div>
                    <div className="accordion-body">
                        <div className="content">
                            <p>Ut vehicula mauris est, sed sodales justo rhoncus eu. Morbi porttitor quam velit, at ullamcorper justo suscipit sit amet. Quisque at suscipit mi, non efficitur velit.<br/><br/>
                            Cras et tortor semper, placerat eros sit amet, porta est. Mauris porttitor sapien et quam volutpat luctus. Nullam sodales ipsum ac neque ultricies varius.</p>
                        </div>
                    </div>
                </article>
                <article className="accordion last-accordion">
                    <div className="accordion-head">
                        <span>Share this to your colleagues</span>
                        <span className="icon">
                            <i className="icon fa fa-chevron-right"></i>
                        </span>
                    </div>
                    <div className="accordion-body">
                        <div className="content">
                            <p>Maecenas suscipit enim libero, vel lobortis justo condimentum id. Interdum et malesuada fames ac ante ipsum primis in faucibus.<br/><br/>
                            Sed eleifend metus sit amet magna tristique, posuere laoreet arcu semper. Nulla pellentesque ut tortor sit amet maximus. In eu libero ullamcorper, semper nisi quis, convallis nisi.</p>
                        </div>
                    </div>
                </article>
            </div>
            </div> */}
        </div>
        </div>
      </section>

     {/* <section className="our-courses" id="courses">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-heading">
            <h2>Our Popular Courses</h2>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="owl-courses-item owl-carousel">
            <div className="item">
              <img src="assets/images/course-01.jpg" alt="Course One"/>
              <div className="down-content">
                <h4>Morbi tincidunt elit vitae justo rhoncus</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$160</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-02.jpg" alt="Course Two"/>
              <div className="down-content">
                <h4>Curabitur molestie dignissim purus vel</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$180</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-03.jpg" alt=""/>
              <div className="down-content">
                <h4>Nulla at ipsum a mauris egestas tempor</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$140</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-04.jpg" alt=""/>
              <div className="down-content">
                <h4>Aenean molestie quis libero gravida</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$120</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-01.jpg" alt=""/>
              <div className="down-content">
                <h4>Lorem ipsum dolor sit amet adipiscing elit</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$250</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-02.jpg" alt=""/>
              <div className="down-content">
                <h4>TemplateMo is the best website for Free CSS</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$270</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-03.jpg" alt=""/>
              <div className="down-content">
                <h4>Web Design Templates at your finger tips</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$340</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-04.jpg" alt=""/>
              <div className="down-content">
                <h4>Please visit our website again</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$360</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-01.jpg" alt=""/>
              <div className="down-content">
                <h4>Responsive HTML Templates for you</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$400</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-02.jpg" alt=""/>
              <div className="down-content">
                <h4>Download Free CSS Layouts for your business</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$430</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-03.jpg" alt=""/>
              <div className="down-content">
                <h4>Morbi in libero blandit lectus cursus</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$480</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <img src="assets/images/course-04.jpg" alt=""/>
              <div className="down-content">
                <h4>Curabitur molestie dignissim purus</h4>
                <div className="info">
                  <div className="row">
                    <div className="col-8">
                      <ul>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                        <li><i className="fa fa-star"></i></li>
                      </ul>
                    </div>
                    <div className="col-4">
                       <span>$560</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     </section> */}

      <section className="our-facts">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-12">
                  <h2>A Few Facts About Our Teaching</h2>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-12">
                      <div className="count-area-content percentage">
                        {/* <div className="count-digit">94</div> */}
                        <div className="count-title">Personalized Teaching</div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="count-area-content">
                        {/* <div className="count-digit">126</div> */}
                        <div className="count-title">Optimal Ratio</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-12">
                      <div className="count-area-content new-students">
                        {/* <div className="count-digit">2345</div> */}
                        <div className="count-title">Customized Projects</div>
                      </div>
                    </div> 
                    <div className="col-12">
                      <div className="count-area-content">
                        {/* <div className="count-digit">32</div> */}
                        <div className="count-title">Experienced Faculty</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-12">
                      <div className="count-area-content new-students">
                        {/* <div className="count-digit">2345</div> */}
                        <div className="count-title">Remedial Support</div>
                      </div>
                    </div> 
                    {/* <div className="col-12">
                      <div className="count-area-content">
                        <div className="count-digit">32</div>
                        <div className="count-title">Experienced Faculty</div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div> 
            <div className="col-lg-6 align-self-center">
              <div className="video">
                <a href="#"><img src="assets/images/play-icon.png" alt=""/></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-us" id="contact" ref={contactRef}>
        <div className="container">
          <div className="row">
            <div className="col-lg-9 align-self-center">
              <div className="row">
                <div className="col-lg-12">
                  <form id="contact" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-12">
                        <h2>Let's get in touch</h2>
                      </div>
                      <div className="col-lg-4">
                        <fieldset>
                          <input
                            name="name"
                            type="text"
                            id="name"
                            placeholder="YOUR NAME..."
                            value={formData.name}
                            onChange={handleChange}
                          />
                          {errors.name && <span className="error">{errors.name}</span>}
                        </fieldset>
                      </div>
                      <div className="col-lg-4">
                        <fieldset>
                          <input
                            name="email"
                            type="email"
                            id="email"
                            placeholder="YOUR EMAIL..."
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.email && <span className="error">{errors.email}</span>}
                        </fieldset>
                      </div>
                      <div className="col-lg-4">
                        <fieldset>
                          <input
                            name="contact"
                            type="text"
                            id="contact"
                            placeholder="CONTACT..."
                            value={formData.contact}
                            onChange={handleChange}
                          />
                          {errors.contact && <span className="error">{errors.contact}</span>}
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <textarea
                            name="message"
                            id="message"
                            placeholder="YOUR MESSAGE..."
                            value={formData.message}
                            onChange={handleChange}
                          ></textarea>
                          {errors.message && <span className="error">{errors.message}</span>}
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <button type="submit" id="form-submit" className="button" disabled={isLoading}> {isLoading ? "Wait... Loading" : "SEND MESSAGE NOW"}</button>
                        </fieldset>
                      </div>
                      {errors.api && <p className="error">{errors.api}</p>}
                      {successMessage && <p className="success">{successMessage}</p>}
                    </div>
                  </form>
                  
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="right-info">
                <ul>
                  {/* <li>
                    <h6>Phone Number</h6>
                    <span>7003423870</span>
                  </li>
                  <li>
                    <h6>Email Address</h6>
                    <span>careersrup@gmail.com</span>
                  </li>
                  <li>
                    <h6>Street Address</h6>
                    <span>Behala</span>
                  </li> */}
                  <li>
                    <h6>Website URL</h6>
                    <span>www.guidetocomputers.org</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>        
      </section>
    </>
  );
}
